import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "form"]

  connect() {
    this.open = false
    this.submitTimeout = null
    this._handleResize = this._handleResize.bind(this)
    window.addEventListener("resize", this._handleResize)
    this._handleResize()
  }

  disconnect() {
    window.removeEventListener("resize", this._handleResize)
    clearTimeout(this.submitTimeout)
  }

  toggle(event) {
    event.preventDefault()
    this.open = !this.open
    this._syncVisibility()
  }

  submit() {
    clearTimeout(this.submitTimeout)
    this.submitTimeout = setTimeout(() => {
      this.formTarget?.requestSubmit()
    }, 300)
  }

  _handleResize() {
    const isDesktop = window.matchMedia("(min-width: 768px)").matches
    if (isDesktop) {
      this.open = true
    }
    this._syncVisibility()
  }

  _syncVisibility() {
    if (!this.hasPanelTarget) return
    const isDesktop = window.matchMedia("(min-width: 768px)").matches
    if (isDesktop) {
      this.panelTarget.classList.remove("hidden", "space-y-6")
      this.panelTarget.classList.add("grid")
    } else if (this.open) {
      this.panelTarget.classList.remove("hidden", "grid")
      this.panelTarget.classList.add("space-y-6")
    } else {
      this.panelTarget.classList.add("hidden")
      this.panelTarget.classList.remove("grid", "space-y-6")
    }
  }
}
